export default __webpack_public_path__ + "locales/tr/Errors.json?hash=1ea47cefe305cec1199e76d77ae271ff";